import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
import { NotificationModule } from '@application/enums/notification-module-enum';
import { EventNotificationType, TaskNotificationType, ActivityNotificationType } from '@application/enums/notification-type-enum';
import { PriorityEnum } from '@application/enums/priority-enum';
// Backend expects enum numeric values; map string enum names to numbers
const NotificationModuleValue = {
    [NotificationModule.Events]: 0,
    [NotificationModule.Activities]: 1,
    [NotificationModule.Tasks]: 2
};
const NotificationTypeValue = {
    // Events (backend enum order)
    [EventNotificationType.EventCreated]: 0,
    [EventNotificationType.EventDeadline]: 1,
    [EventNotificationType.EventRescheduled]: 2,
    // Activities
    [ActivityNotificationType.BirthdayCelebration]: 3,
    [ActivityNotificationType.WorkAnniversary]: 4,
    [ActivityNotificationType.BirthAdoption]: 5,
    [ActivityNotificationType.Retirement]: 6,
    [ActivityNotificationType.MarriageRegistration]: 7,
    [ActivityNotificationType.WeddingAnniversary]: 8,
    [ActivityNotificationType.EmployeeOnboarding]: 9,
    [ActivityNotificationType.EmployeeDeparture]: 10,
    [ActivityNotificationType.EmployeeDeath]: 11,
    [ActivityNotificationType.EmployeeIllness]: 12,
    [ActivityNotificationType.CompanyAnniversary]: 13,
    // Tasks
    [TaskNotificationType.TaskAssigned]: 14,
    [TaskNotificationType.TaskDeadlineApproaching]: 15,
    [TaskNotificationType.TaskCompleted]: 16,
    // Transport
    [EventNotificationType.VehicleDriverNumberMissing]: 17,
    // Legacy mapping: former MarriageAnniversary (value 5) should be treated as WeddingAnniversary
    MarriageAnniversary: 7
};
// Backend enum now matches frontend: High=0, Medium=1, Low=2, None=3
const PriorityEnumValue = {
    [PriorityEnum.High]: 0,
    [PriorityEnum.Medium]: 1,
    [PriorityEnum.Low]: 2,
    [PriorityEnum.None]: 3
};
const normalizePriority = (val) => {
    if (val === null || val === undefined)
        return null;
    if (typeof val === 'number')
        return val;
    return PriorityEnumValue[val];
};
const normalizeCreatePayload = (payload) => {
    return {
        ...payload,
        module: typeof payload.module === 'number'
            ? payload.module
            : NotificationModuleValue[payload.module],
        notificationType: typeof payload.notificationType === 'number'
            ? payload.notificationType
            : NotificationTypeValue[payload.notificationType],
        taskPriority: normalizePriority(payload.taskPriority),
        timingSettings: payload.timingSettings?.map((ts) => ({
            ...ts,
            priorityType: normalizePriority(ts.priorityType)
        })) ?? []
    };
};
const normalizeUpdatePayload = (payload) => {
    return {
        ...payload,
        taskPriority: normalizePriority(payload.taskPriority),
        timingSettings: payload.timingSettings?.map((ts) => ({
            ...ts,
            priorityType: normalizePriority(ts.priorityType)
        })) ?? []
    };
};
const getAllNotificationPreferences = () => {
    return vdkEmHappinessPortalApi.get('/notificationpreferences/get-all');
};
const getNotificationPreferencesByModule = (module) => {
    return vdkEmHappinessPortalApi.get(`/notificationpreferences/by-module/${module}`);
};
const getNotificationPreferenceById = (id) => {
    return vdkEmHappinessPortalApi.get(`/notificationpreferences/${id}`);
};
const createNotificationPreference = (payload) => {
    return vdkEmHappinessPortalApi.post('/notificationpreferences/create', normalizeCreatePayload(payload));
};
const updateNotificationPreference = (id, payload) => {
    return vdkEmHappinessPortalApi.put(`/notificationpreferences/${id}`, normalizeUpdatePayload(payload));
};
const deleteNotificationPreference = (id) => {
    return vdkEmHappinessPortalApi.delete(`/notificationpreferences/${id}`);
};
const getModuleCompanies = (module) => {
    return vdkEmHappinessPortalApi.get(`/notificationpreferences/module-companies/${module}`);
};
const updateModuleCompanies = (payload) => {
    return vdkEmHappinessPortalApi.put('/notificationpreferences/module-companies', {
        ...payload,
        module: typeof payload.module === 'number'
            ? payload.module
            : NotificationModuleValue[payload.module]
    });
};
const NotificationPreferencesApi = {
    getAllNotificationPreferences,
    getNotificationPreferencesByModule,
    getNotificationPreferenceById,
    createNotificationPreference,
    updateNotificationPreference,
    deleteNotificationPreference,
    getModuleCompanies,
    updateModuleCompanies
};
export default NotificationPreferencesApi;
